module.exports = __webpack_public_path__ + "static/media/fantasycoach_mleaderboard_320x50@2x.112a1fe9.jpg";